var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 88.276H8.828A8.828 8.828 0 0 0 0 97.103v317.793a8.829 8.829 0 0 0 8.828 8.828h494.345a8.829 8.829 0 0 0 8.828-8.828V97.103a8.83 8.83 0 0 0-8.829-8.827z",
    fill: "#73af00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 97.103a8.829 8.829 0 0 0-8.828-8.828h-39.501L256 224.337 48.329 88.276H8.828A8.828 8.828 0 0 0 0 97.103v22.836L207.671 256 0 392.061v22.836a8.829 8.829 0 0 0 8.828 8.828h39.501L256 287.663l207.671 136.061h39.501a8.829 8.829 0 0 0 8.828-8.828V392.06L304.329 256 512 119.939V97.103z",
    fill: "#ffe15a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#464655"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 119.939v272.122L304.329 256zM0 392.061V119.939L207.671 256z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJm);
export default __webpack_public_path__ + "static/media/jm.5212e33f9799b52fe59268812aaeae9f.svg";
export { ForwardRef as ReactComponent };